import React from "react";
import { Published } from "../../../components/article/published";

import Layout from "../../../components/layout/layout";

export default function ArticlePublished({ component, ...rest }) {
  return <Layout Component={Published} controlsDisabled={true} {...rest} />;
}
